import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source"];
  static values = { copiedText: String };

  copy(e) {
    navigator.clipboard.writeText(this.sourceTarget.innerText);

    if (this.copiedTextValue) {
      const originalContent = e.target.innerHTML;
      e.target.innerHTML = this.copiedTextValue;

      setTimeout(() => {
        e.target.innerHTML = originalContent;
      }, 2000);
    }
  }
}
